import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import { ConstantsService } from '../../../services/constants.service';
import { CatalogosSatService } from '../../../services/catalogos-sat-service';

declare var moment;
declare var $;

@Component({
  selector: 'app-modal-nota-credito',
  templateUrl: './modal-nota-credito.component.html',
  styleUrls: ['./modal-nota-credito.component.scss']
})
export class ModalNotaCreditoComponent implements OnInit {

  public modal: any = null;
  public cxc:any;
  public api_url:string;

  //Modelos
  public formasPago: any[] = [];
  public fechaPagoModel: any;
  public tipoFacturaModel: any;
  
  //Helpers
  public formaPagoSeleccionado: any = {};
  public metodoPagoSeleccionado: any = {};
  public tipoFacturaOptions: any = {};
  public loading:boolean=false;
  public loadingFormasPago:boolean=false;
  public loadingTipoFactura:boolean=false;
  public errors: any = {};

  @ViewChild('content') private content: TemplateRef<any>;
  @Output() public modalClosed:EventEmitter<any> = new EventEmitter;

  constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
    private constant: ConstantsService, 
    private modalService: NgbModal,
    private satService: CatalogosSatService) { }

  ngOnInit() {
    moment.locale('es');
    this.api_url = this.constant.apiURL;
    this.cargarFormasPago();
    //this.cargarTipoFactura();
  }

  public openModal(cxc){
    this.cxc = cxc;
    this.fechaPagoModel = cxc.fecha_factura;
    setTimeout( () => {
      $('#fechaPago').daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        minDate: this.isoToMX(this.fechaPagoModel),
        locale: {
          format: 'DD/MM/YYYY'
        }
      });
    }, 500);
    this.modal = this.modalService.open(this.content, { size: 'lg' });
  }

  isoToMX(dateString){
    const year = dateString.slice(0,4);
    const month = dateString.slice(5,7);
    const day = dateString.slice(8,10);
    
    return  day+'/'+month+'/'+year;
  }

  public generarFactura(){
    this.loading = true;
    const nota = {};
    nota["id_cuenta_por_cobrar"] = this.cxc.id_cuenta_por_cobrar;
    nota["fecha_comprobante"] = this.fechaPagoModel;
    nota["id_facturas_cuentas"] = this.cxc.id_facturas_cuentas;
    nota["forma_pago"] = this.formaPagoSeleccionado["codigo"];
    //nota["tipo_factura"] = this.tipoFacturaModel["codigo"];

    this.cuentas_por_cobrar_service.createMovimientosObra(nota)
    .subscribe(
      (response)=>{
        this.loading = false;
        this.closeModal(true);
      },
      (error)=>{
        this.loading = false;
        alert("ERROR:: "+JSON.stringify(error));
      }
    );
  }

  public closeModal(reloadParent) {
    this.modal.close();
    if(this.modalClosed){
      this.modalClosed.emit(reloadParent);
    }
  }

  private cargarFormasPago(){
    this.loadingFormasPago = true;
    this.satService.obtenerFormasPago()
    .subscribe(
      (response)=>{
        let formasPago = response.json().content;
        this.formasPago = formasPago;
        console.log("this.formasPago: ",this.formasPago);
        this.formaPagoSeleccionado = this.formasPago.find(val => Number(val["default"]) == 1);
        this.loadingFormasPago = false;
      },
      (error)=>{
        this.loadingFormasPago = false;
        alert("ERROR:: "+JSON.stringify(error));
      }
    );
  }

  /**
   * Obtiene el catálogo de notas de crédito.
  */ 
  cargarTipoFactura(){
    this.loadingTipoFactura = true;
    this.satService.getSatConceptosNotas()
      .subscribe(response => {
        const content = response.json().content;
        console.log("getTipoFactura content: ",content);
        this.tipoFacturaOptions = content;
        this.tipoFacturaModel = this.tipoFacturaOptions.find(val => Number(val["default"] == 1));
        this.loadingTipoFactura = false;
      }, (error) => {
        // se revisan errores 403 - 500
        if (error == 400) {
          console.log('getTipoFactura - error 400 ' , error);
        }else{
          console.log('getTipoFactura error:' , error);
        }
        this.loadingTipoFactura = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-cxc/modal-nota-credito/modal-nota-credito.component.ts